import { Box } from '@mui/material';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { FormTitleBox, TableBodySkeleton } from '../../common/components';
import InternalOrdersDataTable from './components/InternalOrdersDataTable';
import InternalOrdersPagination from './components/InternalOrdersPagination';
import InternalOrderDialog from './components/InternalOrderDialog';
import InternalOrderDetailDialog from './components/InternalOrderDetailDialog';
import ReceiveStockTransferDialog from './components/ReceiveStockTransferDialog';
import { useInternalOrdersTable } from './hooks/useInternalOrdersTable';

const InternalOrdersTable = () => {
  const {
    data,
    isLoading,
    isSaving,
    isProcessing,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    searchTerm,
    dialogOpen,
    detailDialogOpen,
    receiveDialogOpen,
    selectedOrder,
    selectedOrderDetail,
    selectedOrderTransfer,
    selectedTransfer,
    detailOrderLoading,
    warehouses,
    projects,
    projectsLoading,
    warehousesLoading,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleOpenDialog,
    handleCloseDialog,
    handleInputChange,
    handleSelectChange,
    handleAddMaterial,
    handleUpdateMaterialQuantity,
    handleRemoveMaterial,
    handleSave,
    handleViewDetail,
    handleCloseDetailDialog,
    handleAuthorizeOrder,
    handleCheckStock,
    handleProcessOrder,
    handleSetConsumptionAuthorization,
    handleOpenReceiveDialog,
    handleCloseReceiveDialog,
    handleRefreshDetailOrder,
  } = useInternalOrdersTable();

  return (
    <Box>
      <FormTitleBox
        title="Stock y Compras | Pedidos técnicos"
        showButton={true}
        buttonText="Nuevo pedido"
        buttonIcon={AddShoppingCartIcon}
        onButtonClick={handleOpenDialog}
        showSearch={true}
        searchLabel="Buscar pedido"
        searchValue={searchTerm}
        onSearchChange={handleSearch}
        searchSize="medium"
      />

      <InternalOrdersDataTable
        data={data}
        isLoading={isLoading}
        onView={handleViewDetail}
        LoadingComponent={TableBodySkeleton}
      />

      {totalPages > 1 && (
        <InternalOrdersPagination
          totalPages={totalPages}
          totalCount={totalCount}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      )}

      <InternalOrderDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        selectedOrder={selectedOrder}
        onInputChange={handleInputChange}
        onSelectChange={handleSelectChange}
        onSave={handleSave}
        warehouses={warehouses}
        warehousesLoading={warehousesLoading}
        projects={projects}
        projectsLoading={projectsLoading}
        searchEnabled={dialogOpen}
        onAddMaterial={handleAddMaterial}
        onUpdateMaterialQuantity={handleUpdateMaterialQuantity}
        onRemoveMaterial={handleRemoveMaterial}
        isSaving={isSaving}
      />

      <InternalOrderDetailDialog
        open={detailDialogOpen}
        onClose={handleCloseDetailDialog}
        order={selectedOrderDetail}
        transfer={selectedOrderTransfer}
        onAuthorizeOrder={handleAuthorizeOrder}
        onCheckStock={handleCheckStock}
        onProcessOrder={handleProcessOrder}
        onSetConsumptionAuthorization={handleSetConsumptionAuthorization}
        onReceiveTransfer={handleOpenReceiveDialog}
        onOrderUpdated={handleRefreshDetailOrder}
        isProcessing={isProcessing}
        isLoading={detailOrderLoading}
      />

      <ReceiveStockTransferDialog
        open={receiveDialogOpen}
        onClose={handleCloseReceiveDialog}
        transfer={selectedTransfer}
      />
    </Box>
  );
};

export default InternalOrdersTable;
